import React from 'react';

import ValidateDevice from "./index.jsx";

const ValidateWithoutPin = () => {
    return (
        <ValidateDevice 
            withPin={false}
        />
    );
}
export { ValidateWithoutPin };